"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MesoInit = void 0;
var cookies = require("browser-cookies");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var MesoInit = /** @class */function (_super) {
  __extends(MesoInit, _super);
  function MesoInit() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MesoInit.prototype.componentDidMount = function () {
    var _this = this;
    this.window = window;
    var _a = this.props,
      advertising = _a.advertising,
      experiment = _a.experiment;
    if (window) {
      if (!(window.meso && window.meso.adblock)) {
        window.meso = window.meso || {};
        window.meso.adblock = {
          enabled: true
        };
      }
      if (advertising) {
        advertising.adBlockerEnabled = window.meso.adblock.enabled;
      }
      this.halt = mobx_1.autorun(function () {
        if (advertising === null || advertising === void 0 ? void 0 : advertising.includeAdLoader) {
          _this.activateBreakpointsFramework();
          _this.initializeTarget();
          _this.activateExperimentsFramework();
        }
      });
    }
  };
  MesoInit.prototype.parseExperiments = function () {
    var _a;
    var result = {};
    var exposures = ((_a = this.props.experiment) === null || _a === void 0 ? void 0 : _a.exposures) || {};
    // Map experiment name to bucket id in result.
    Object.keys(exposures).forEach(function (key) {
      if (exposures[key].hasOwnProperty('bucket')) {
        result[key] = exposures[key].bucket;
      }
    });
    return result;
  };
  MesoInit.prototype.getPrivacyConsent = function () {
    var _a, _b, _c, _d;
    // Retrieve data from context.
    var context = this.props.context;
    var optInPrivacy = (_a = context === null || context === void 0 ? void 0 : context.site) === null || _a === void 0 ? void 0 : _a.optInPrivacyInfo;
    var OIP_COOKIE = 'OIP';
    var OIP_OPT_IN = 'gdpr|1';
    var oipCookieValue = cookies.get(OIP_COOKIE);
    var privacyTrackingStateMap = {
      CAN_TRACK: true,
      CAN_NOT_TRACK: false
    };
    var privacySellStateMap = {
      CAN_SELL: true,
      CAN_NOT_SELL: false
    };
    var canTrack = privacyTrackingStateMap[context === null || context === void 0 ? void 0 : context.privacyTrackingState] || (optInPrivacy === null || optInPrivacy === void 0 ? void 0 : optInPrivacy.canTrack) || (oipCookieValue === null || oipCookieValue === void 0 ? void 0 : oipCookieValue.startsWith(OIP_OPT_IN)) || false;
    var canSell = (_c = privacySellStateMap[(_b = context === null || context === void 0 ? void 0 : context.site) === null || _b === void 0 ? void 0 : _b.privacySellState]) !== null && _c !== void 0 ? _c : (_d = optInPrivacy === null || optInPrivacy === void 0 ? void 0 : optInPrivacy.canSell) !== null && _d !== void 0 ? _d : true;
    return {
      canTrack: canTrack,
      canSell: canSell
    };
  };
  MesoInit.prototype.componentWillUnmount = function () {
    if (typeof this.halt === 'function') {
      this.halt();
    }
  };
  /**
   * Push the target to the initialize event queue
   */
  MesoInit.prototype.initializeTarget = function () {
    var _a, _b;
    var _c = this.props,
      advertising = _c.advertising,
      context = _c.context;
    var pageName = (advertising === null || advertising === void 0 ? void 0 : advertising.adPageIdOverride) || (advertising === null || advertising === void 0 ? void 0 : advertising.triggeredPageName);
    if (!pageName) {
      return;
    }
    var siteId = ((_a = context === null || context === void 0 ? void 0 : context.site) === null || _a === void 0 ? void 0 : _a.id) || '';
    var locale = (context === null || context === void 0 ? void 0 : context.locale) || '';
    var variant = new URLSearchParams(window.location.search).get('overrideADSVariant') || 'pwa';
    var brand = ((_b = context === null || context === void 0 ? void 0 : context.site) === null || _b === void 0 ? void 0 : _b.brand) || '';
    var _d = this.getPrivacyConsent(),
      canTrack = _d.canTrack,
      canSell = _d.canSell;
    advertising.canTrack = canTrack;
    // Override with props data or use context.
    var target = {
      type: 'target',
      pageId: pageName,
      siteId: siteId,
      locale: locale,
      variant: variant,
      brand: brand,
      canTrack: canTrack,
      canSell: canSell
    };
    // Push the target to ADS endpoint to load ads.
    window.meso = window.meso || {};
    window.meso.initialize = window.meso.initialize || [];
    window.meso.initialize.push(target);
  };
  /**
   * Push the application to the breakpoints framework.
   */
  MesoInit.prototype.activateBreakpointsFramework = function () {
    if (this.window) {
      this.window.meso = this.window.meso || {};
      this.window.meso.breakpoints = this.window.meso.breakpoints || [];
      this.window.meso.breakpoints.push({
        type: "platform",
        platform: "bernie"
      });
    }
  };
  MesoInit.prototype.activateExperimentsFramework = function () {
    window.meso = window.meso || {};
    window.meso.experiments = window.meso.experiments || [];
    window.meso.experiments.push({
      type: 'update',
      experiments: this.parseExperiments()
    });
  };
  MesoInit.prototype.render = function () {
    return this.props.children;
  };
  MesoInit = __decorate([mobx_react_1.inject('context', 'advertising', 'experiment')], MesoInit);
  return MesoInit;
}(React.Component);
exports.MesoInit = MesoInit;